<template>
  <div v-if="userLogs && userLogs.length > 0">
    <div v-for="(userLog, index) in userLogs" :key="`userLog-${index}`">
      <div class="pt-2">
        <v-btn @click="toggle(index)" class="my-0 ml-1 mr-0" small v-if="getUserLogs(userLog) && getUserLogs(userLog).length > 0" icon>
          <v-icon>{{ hide[index] ? 'expand_more' : 'expand_less' }}</v-icon>
        </v-btn>
        <v-chip color="transparent" small class="ma-0" label>
          <v-avatar>
            <v-icon class="pl-1" :color="getColor(userLog)">
              {{ getIcon(userLog) }}
            </v-icon>
          </v-avatar>
          {{ getTimeStamp(userLog) }}
        </v-chip>
      </div>
      <ul class="pa-2 mx-1 card-bg-1 rounded-border">
        <li class="list-style-none" v-for="(line, lineIndex) in getMessage(userLog)" :key="`${index}-line-${lineIndex}`" v-html="line" />
      </ul>
      <template v-if="!hide[index] && getUserLogs(userLog) && getUserLogs(userLog).length > 0">
        <UserLogs class="pl-5" :userLogs="getUserLogs(userLog)" />
      </template>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { prettyTimeFormat } from '@/components/mixins/MomentUtil'
  import { logTypesIndexByValue } from '@/helpers/serviceLogs'

  export default {
    name: 'UserLogs',
    props: {
      userLogs: Array,
    },
    data: () => ({
      expand: true,
      hide: {},
    }),
    methods: {
      formatDate(date) {
        return moment(date).format(prettyTimeFormat)
      },
      splitNewLine(message) {
        if (!message) return []
        else return message.split('\n')
      },
      getColor(userLog) {
        let eventLevel = (userLog.EventLevel != null) ? userLog.EventLevel : (userLog.eventLevel)
        if (eventLevel == null) return 'secondary'

        return logTypesIndexByValue[eventLevel].color
      },
      getIcon(userLog) {
        let eventLevel = (userLog.EventLevel != null) ? userLog.EventLevel : (userLog.eventLevel)
        if (eventLevel == null) return 'secondary'
        return logTypesIndexByValue[eventLevel].icon
      },
      getMessage(userLog) {
        let message = userLog.Message || userLog.message || ''
        return this.splitNewLine(message)
      },
      getUserLogs(userLog) {
        return userLog.UserLogs || userLog.userLogs
      },
      getTimeStamp(userLog) {
        let timeStamp = userLog.TimeStamp || userLog.timeStamp
        return this.formatDate(timeStamp)
      },
      toggle(index) {
        if (!this.hide[index]) this.$set(this.hide, index, true)
        else this.hide[index] = false
      },
    },
  }
</script>